import { useContext, useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  TextField,
  IconButton
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import NextApptCalendar from './NextApptCalendar';
import PropTypes from 'prop-types';
import { useBebackApi } from '../hooks/useBebackApi';
import { DateTime } from 'luxon';
import FeedbackContext from '../context/FeedbackContext';

const NextApptReadModal = ({open, onClose, woData, setOpenErrorPopup, setErrorMessage}) => {
  const [apptData, setApptData] = useState([]);
  const { getApptById } = useBebackApi()
  const { setIsLoading } = useContext(FeedbackContext);

  function toHoursAndMinutes(totalMinutes) {
    const minutes = totalMinutes % 60;
    const hours = Math.floor(totalMinutes / 60);
    const timeFormat = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = (hours % 12) || 12;
  
    return `${padTo2Digits(formattedHours)}:${padTo2Digits(minutes)} ${timeFormat}`;
  }
  
  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const res = await getApptById(woData.NextAppointmentId);
      if(res.error) {
        setErrorMessage('Unable to retrieve information. Please try again.');
        setOpenErrorPopup(true);
        setApptData([])
        onClose();
      } else {
        setApptData(res)
      }
      setIsLoading(false);
    }
    fetchData()
  }, [open])

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      // onClose={onClose}
      maxWidth='md'
      aria-labelledby='appointment-title'
      fullWidth={true}
      PaperProps={{
        sx: {
          maxHeight: '600px'
        },
      }}
    >
      <DialogTitle
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        id='appointment-title'
      >
        Appointment Details
        <IconButton
          aria-label='close modal'
          onClick={onClose}
          sx={{ alignSelf: "flex-end" }}
          color='error'
        >
          <CloseIcon style={{ padding: 0 }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ display: "grid" }}>
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <NextApptCalendar value={DateTime.fromISO(apptData.date)} readOnly={true}/>
          </Grid>
          <Grid container item xs={7} spacing={2}>
            <Grid item xs={12}>
              <TextField 
                fullWidth
                label="Start time" 
                variant="standard"
                value={apptData?.start_time ? toHoursAndMinutes(apptData.start_time) : ''}
                InputProps={{
                  readOnly: true,
                }} 
              />
            </Grid>
            <Grid item xs={6}>
              <TextField 
                fullWidth
                label="Last Name" 
                variant="standard"
                value={apptData?.last_name ? apptData.last_name : ''}
                InputProps={{
                  readOnly: true,
                }} 
              />
            </Grid>
            <Grid item xs={6}>
              <TextField 
                fullWidth
                label="First Name" 
                variant="standard" 
                value={apptData?.first_name ? apptData.first_name : ''}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField 
                fullWidth
                label="Email" 
                variant="standard"
                value={(apptData?.email && apptData.email !== null) ? apptData.email : ''}
                InputProps={{
                  readOnly: true,
                }} 
              />
            </Grid>
            <Grid item xs={6}>
              <TextField 
                fullWidth
                label="Service" 
                variant="standard"
                value={apptData?.service ? apptData.service : ''}
                InputProps={{
                  readOnly: true,
                }} 
              />
            </Grid>
            <Grid item xs={6}>
              <TextField 
                fullWidth
                label="Status" 
                variant="standard"
                value={apptData?.appt_status_description ? apptData.appt_status_description : ''}
                InputProps={{
                  readOnly: true,
                }} 
              />
            </Grid>
            <Grid item xs={6}>
              <TextField 
                fullWidth
                label="Next Appointment ID" 
                variant="standard"
                value={woData?.NextAppointmentId ? woData.NextAppointmentId : 'Please wait'}
                InputProps={{
                  readOnly: true,
                }} 
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

NextApptReadModal.propTypes = {
  open: PropTypes.bool, 
  onClose: PropTypes.func,
  woData: PropTypes.object,
  setOpenErrorPopup: PropTypes.func,
  setErrorMessage: PropTypes.func
}

export default NextApptReadModal;
